import { HttpService } from "data/http-service";
import { AIHit, Feedback } from "domain/entities/ai-search.entities";
import { Snackbar } from "ui/pages/snackbar";
import { translate } from "ui/i18n";
import { AxiosError } from "axios";
import { AISearchGateway } from "domain/ai-search/ai-search.gateway";

export class AISearchHttpGateway implements AISearchGateway {
  async sendAIFeedback(feedback: Feedback): Promise<{
    success: boolean;
  }> {
    return HttpService.post("ai-search-reviews", feedback)
      .then((response) => {
        if (response.status === 201) {
          return {
            success: true,
          };
        } else {
          Snackbar.showError({
            title: translate("ns1:AI.SendAIFeedbackError"),
          });
          return {
            success: false,
          };
        }
      })
      .catch((error: AxiosError) => {
        Snackbar.showError({
          title: translate("ns1:AI.SendAIFeedbackError"),
        });
        return { success: false };
      });
  }

  async getTechniquesByElasticAISearch({
    search,
    limit,
  }: {
    search: string;
    limit?: number;
  }): Promise<{
    techniqueHits: AIHit[];
    success: boolean;
  }> {
    return HttpService.get("techniques", {
      params: { search, limit },
      api: "elastic-service",
    })
      .then((response) => {
        if (response.status === 200 && response.data.hits) {
          return {
            techniqueHits: response.data.hits,
            success: true,
          };
        } else {
          Snackbar.showError({
            title: translate("ns1:AI.SearchTechniquesError"),
          });
          return {
            techniqueHits: [],
            success: false,
          };
        }
      })
      .catch((error: AxiosError) => {
        Snackbar.showError({
          title: translate("ns1:AI.SearchTechniquesError"),
        });
        return { techniqueHits: [] as AIHit[], success: false };
      });
  }

  /**
   * gemini ai service search for techniques
   * @param search
   * @returns
   */
  async getTechniquesByAISearch({
    search,
    limit,
  }: {
    search: string;
    limit?: number;
  }): Promise<{
    techniqueHits: AIHit[];
    success: boolean;
    quotaExceeded: boolean;
  }> {
    return HttpService.post(
      "techniques",
      { prompt: search, limit },
      {
        api: "ai-service",
      }
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          return {
            techniqueHits: response.data,
            success: true,
            quotaExceeded: false,
          };
        } else {
          Snackbar.showError({
            title: translate("ns1:AI.SearchTechniquesError"),
          });
          return {
            techniqueHits: [],
            success: false,
            quotaExceeded: false,
          };
        }
      })
      .catch((error: AxiosError) => {
        if (error.status === 403) {
          return {
            techniqueHits: [] as AIHit[],
            success: false,
            quotaExceeded: true,
          };
        }
        Snackbar.showError({
          title: translate("ns1:AI.SearchTechniquesError"),
        });
        return {
          techniqueHits: [] as AIHit[],
          success: false,
          quotaExceeded: false,
        };
      });
  }
}
